import React, {useState} from "react";
import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Images
import macbook from "assets/images/contact_us.png";
import Grid2 from "@mui/material/Grid2";
import {api} from "../../../../api/api";

function Newsletter() {
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requestData = {
      contact,
      email,
      message,
    };

    try {
      await api.post("/api/email/contact-requests", requestData);
      // 전송 성공 후 처리 (예: 성공 메시지 표시, 입력 필드 초기화)
      toast.success("문의가 성공적으로 전송되었습니다.");
      setContact("");
      setEmail("");
      setMessage("");
    } catch (error) {
      // 전송 실패 후 처리 (예: 에러 메시지 표시)
      toast.error("문의 전송에 실패했습니다. 다시 시도해주세요.");
      console.error("문의 전송에 실패했습니다.", error);
    }
  };

  return (
      <MKBox component="section" pt={6} my={6}>
        <Container>
          <Grid2 container alignItems="center">
            <Grid2 size={{ md: 6 }} sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}>
              <MKTypography variant="h4">
                프로젝트 문의하기: 당신의 아이디어가 현실로 피어나는 첫 시작
              </MKTypography>
              <MKTypography variant="body2" color="dark" mt={3} mb={3}>
                당신의 머릿속에만 존재하던 빛나는 아이디어가 현실의 모습으로 첫 발을 내딛는 순간
                <br />
                우리 LEAP PLACE는 그 여정을 함께 시작할 준비가 되어 있습니다.
                <br />
                지금, 당신의 이야기를 들려주세요. <br />
                우리의 만남은 당신의 아이디어가 세상에 빛을 발하는 감동적인 여정의 시작이 될 것입니다.
              </MKTypography>
              <Grid2 container spacing={1}>
                <MKBox p={3}>
                  <MKBox
                      width="100%"
                      component="form"
                      method="post"
                      autoComplete="off"
                      onSubmit={handleSubmit}
                  >
                    <Grid2 container spacing={3}>
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <MKInput
                            type="text"
                            variant="standard"
                            label="전화번호"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, sm: 6 }}>
                        <MKInput
                            type="email"
                            variant="standard"
                            label="Email"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <MKInput
                            variant="standard"
                            label="무엇을 도와드릴까요?"
                            placeholder="문의 내용을 250자 내로 작성하여 주세요. 확인 후 저희가 연락드리겠습니다."
                            InputLabelProps={{ shrink: true }}
                            multiline
                            fullWidth
                            rows={4}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                      </Grid2>
                    </Grid2>
                    <Grid2 container justifyContent="center" size={{ xs: 12 }} mt={5} mb={2}>
                      <MKButton type="submit" variant="gradient" color="info">
                        문의 하기
                      </MKButton>
                    </Grid2>
                  </MKBox>
                </MKBox>
              </Grid2>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 5 }} sx={{ ml: "auto" }}>
              <MKBox position="relative">
                <MKBox component="img" src={macbook} alt="macbook" width="100%" />
              </MKBox>
            </Grid2>
          </Grid2>
        </Container>
      </MKBox>
  );
}

export default Newsletter;